<template>
  <div class="profile-field">
    <component
      :is="fieldComponent"
      :value="value"
      :field="field"
      :error="error"
      :preview="preview"
      :editable="editable"
      @input="$emit('update', $event)"
      @change="$emit('change')"
    />
  </div>
</template>

<script>
import * as FieldComponent from "./field-types";

export default {
  props: ["field", "value", "preview", "editable", "error"],
  computed: {
    fieldComponent() {
      const { fieldType, isSystem } = this.field;

      return isSystem
        ? FieldComponent.systemFieldComponents[fieldType]
        : FieldComponent.customFieldComponents[fieldType];
    },
  },
};
</script>

<style lang="scss" src="./profile-field.scss"></style>
